import store from "@/store";
import { getVipType } from "@/utils/role/useVipType";
import { Modal, Button, message } from "antd";
import pIcon1 from "./assets/personal/icon-1.png";
import pIcon2 from "./assets/personal/icon-2.png";
import pIcon3 from "./assets/personal/icon-3.png";
import pIcon4 from "./assets/personal/icon-4.png";
import bgPersonal from "./assets/img-personal-bg.png";
import vipBgPersonal from "./assets/vip-bg-personal.png";
import bgSchool from "./assets/img-school-bg.png";
import { APP_URL, VERSION_GUIDE_URL } from "@/config/constants";
import { isJwInlandApp, isJwIntlApp } from "@/utils/app/env";
import report from "@/utils/report/report";
import xzbIcon1 from "./assets/xzb/icon-1.png";
import xzbIcon2 from "./assets/xzb/icon-2.png";
import xzbQrcode from "./assets/xzb/img-qrcode.png";
import xgkIcon1 from "./assets/xgk/icon-1.png";
import xgkIcon2 from "./assets/xgk/icon-2.png";
import xgkIcon3 from "./assets/xgk/icon-3.png";
import xgkIcon4 from "./assets/xgk/icon-4.png";
import xgkIcon5 from "./assets/xgk/icon-5.png";
import rolePermMap from "@/utils/role/rolePermMap";
import imgInsBg from "./assets/imgg-ins-bg.png";
import iconIns1 from "./assets/ins/icon-1.png";
import iconIns2 from "./assets/ins/icon-2.png";
import { IVipRoleType } from "@/services/user";

const commonModalProps = {
  icon: null,
  width: 640,
  footer: false,
  wrapClassName: "modal-content-no-padding",
  closable: true,
  centered: true,
};

interface Config {
  reason?: string;
}

// 开通个人VIP
const showPersonalVipModal = (config?: Config) => {
  const { reason } = config || {};

  const pDescList = [
    {
      icon: pIcon1,
      name1: "一键",
      name2: "秒排",
      primary: "name2",
    },
    {
      icon: pIcon2,
      name1: "广泛",
      name2: "使用",
      primary: "name1",
    },
    {
      icon: pIcon3,
      name1: "专属",
      name2: "客服",
      primary: "name1",
    },
    {
      icon: pIcon4,
      name1: "持续",
      name2: "迭代",
      primary: "name2",
    },
  ];

  Modal.confirm({
    ...commonModalProps,
    content: (
      <div
        style={{
          width: 640,
          height: 400,
          background: `url(${vipBgPersonal}) no-repeat`,
          backgroundSize: "100% 100%",
          position: "relative",
        }}
      >
        {/* 背景图为完整设计稿（含头部提示文案与底部两个"立即开通"按钮），
            此处用透明热区覆盖图内左右两个"立即开通"按钮，点击均跳站内付费页 */}
        <div
          style={{
            opacity: 0,
            display: "flex",
            justifyContent: "center",
            gap: 16,
            position: "absolute",
            bottom: 45, // 距离底部40px
            left: 45,
          }}
        >
          <Button
            style={{ width: 260, backgroundColor: "#37AEB9" }}
            type="primary"
            onClick={() => {
              report.event("upgrade_entry_click", { target: "personal-vip" });
              window.open(`${APP_URL}#/pay-vip`);
            }}
          >
            个人版VIP
          </Button>
          <Button
            style={{ width: 260, backgroundColor: "#37AEB9", marginLeft: 60 }}
            type="primary"
            onClick={() => {
              report.event("upgrade_entry_click", { target: "personal-svip" });
              window.open(`${APP_URL}#/pay-vip`);
            }}
          >
            个人版SVIP
          </Button>
        </div>
      </div>
    ),
  });
};

// 快教务版本导购落地页地址（带来源标识，便于落地页统计各入口转化）
export const getVersionGuideUrl = (source: string) => `${VERSION_GUIDE_URL}?source=${source}`;

// 直达某个版本档位的导购页（跳过首页选档）：如 tier="pro" → 走班排课版页
export const getVersionGuideTierUrl = (tier: string, source: string) =>
  `${VERSION_GUIDE_URL}${tier}/?source=${source}`;

interface KuaijwVipConfig extends Config {
  plan?: "basic" | "ncee";
  /** 指定导购页档位（如 "pro" 走班排课版）；不传则落导购首页 */
  tier?: string;
  /** 正文动词，默认「开通」；对方已有低档位权益、这次是往上升时说「升级到」更准确 */
  verb?: "开通" | "升级到";
}

// 开通快教务（协同排课基础版 ¥398/年起 或 走班排课 ¥980/年起）：
// 教务版权益（协同/分享/监考/数量上限等）的拦截弹窗，按"含该权益的最低版本"点名档位
const showKuaijwVipModal = (config?: KuaijwVipConfig) => {
  const { reason, plan = "basic", tier, verb = "开通" } = config || {};
  const isNcee = plan === "ncee";
  const planName = isNcee ? "快教务走班排课" : "快教务协同排课基础版";
  const priceHint = isNcee ? "¥980/年起" : "¥398/年起";
  const subtitle = isNcee
    ? "在基础版全部功能之上，支持新高考选科、智能分班、走班排课"
    : "包含个人版SVIP全部功能，支持多人协同排课";
  const featureList = isNcee
    ? [
        { icon: xgkIcon1, name1: "学生选科", name2: "智能分班" },
        { icon: xgkIcon4, name1: "走班排课", name2: "开班计划" },
      ]
    : [
        { icon: xzbIcon1, name1: "行政班排课", name2: "不限班级数" },
        { icon: xzbIcon2, name1: "多人协同", name2: "2个团队账号" },
      ];

  report.event("upgrade_modal_show", { plan, reason: reason || "" });

  return Modal.confirm({
    ...commonModalProps,
    content: (
      <div
        style={{
          width: 640,
          padding: 40,
          background: `url(${bgSchool}) no-repeat`,
          backgroundSize: "100% 100%",
        }}
      >
        <div style={{ height: 130 }}>
          <div
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#1D2129",
              width: 520,
              lineHeight: 1.3,
              marginBottom: 12,
            }}
          >
            {reason ? `${reason}，` : ""}
            {verb}
            <span style={{ color: "#814F13" }}>{planName}</span>
            可使用该功能
          </div>
          <div style={{ fontSize: 15, color: "#4E5969" }}>
            {planName}
            {priceHint}，{subtitle}
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 32 }}>
          <div
            style={{
              padding: "24px 16px",
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#FFF8E9",
            }}
          >
            {featureList.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  fontWeight: 500,
                  marginBottom: index === 0 ? 16 : 0,
                }}
              >
                <img src={item.icon} alt="" style={{ width: 24, height: 24, marginRight: 16 }} />
                <span>{item.name1}</span>
                <span style={{ color: "#814F13" }}>{item.name2}</span>
              </div>
            ))}
          </div>
          <div
            style={{
              padding: 10,
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#FFF8E9",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img src={xzbQrcode} style={{ width: 92, height: 92 }} alt="" />
            <div style={{ fontSize: 12, color: "#4E5969", textAlign: "center" }}>
              <div>扫描二维码，联系客服可</div>
              <div>
                申请<span style={{ color: "#814F13" }}>免费体验</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Button
            style={{ width: 88, backgroundColor: "#814F13" }}
            type="primary"
            onClick={() => {
              report.event("upgrade_entry_click", {
                target: isNcee ? "kuaijw-ncee" : "kuaijw-basic",
                reason: reason || "",
              });
              window.open(
                tier
                  ? getVersionGuideTierUrl(tier, `kuaipk-upgrade-${plan}`)
                  : getVersionGuideUrl(`kuaipk-upgrade-${plan}`),
              );
            }}
          >
            查看权益
          </Button>
        </div>
      </div>
    ),
  });
};

// 方案回收站（新高考走班排课版权益）在行政班排课模块的上锁引导：
// 一句话说清能力（90 天内误删可恢复）+ 点名升级档位，CTA 直落导购页走班排课版档位。
// 行政班的用户手上已经有更低的档位，这次是往上升，正文用「升级到」而不是「开通」
export const showSchemaRecycleUpgradeModal = () =>
  showKuaijwVipModal({
    reason: "恢复 90 天内误删的排课方案",
    plan: "ncee",
    tier: "pro",
    verb: "升级到",
  });

// 开通校园版VIP
const showSchoolVipModal = (config?: Config) => {
  const { reason } = config || {};

  return Modal.confirm({
    ...commonModalProps,
    content: (
      <div
        style={{
          width: 640,
          padding: 40,
          background: `url(${bgSchool}) no-repeat`,
          backgroundSize: "100% 100%",
        }}
      >
        <div style={{ height: 130 }}>
          <div
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#1D2129",
              width: 360,
              lineHeight: 1.3,
              marginBottom: 12,
            }}
          >
            {reason ? `${reason}，` : ""}升级<span style={{ color: "#814F13" }}>个人SVIP</span>
            解锁方案最大班级数、方案数等更多功能权益
          </div>
          <div style={{ fontSize: 15, color: "#4E5969" }}>升级SVIP，开启10秒出课表轻松排课之旅</div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 32 }}>
          <div
            style={{
              padding: "24px 16px",
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#FFF8E9",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: 16,
                fontWeight: 500,
                marginBottom: 16,
              }}
            >
              <img src={xzbIcon1} alt="" style={{ width: 24, height: 24, marginRight: 16 }} />
              <span>不限班级数量</span>
              <span style={{ color: "#814F13" }}>不限方案数量</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", fontSize: 16, fontWeight: 500 }}>
              <img src={xzbIcon2} alt="" style={{ width: 24, height: 24, marginRight: 16 }} />
              <span>临时调代课</span>
              <span style={{ color: "#814F13" }}>多维度课时统计</span>
            </div>
          </div>
          <div
            style={{
              padding: 10,
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#FFF8E9",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img src={xzbQrcode} style={{ width: 92, height: 92 }} alt="" />
            <div style={{ fontSize: 12, color: "#4E5969", textAlign: "center" }}>
              <div>扫描二维码，联系客服可</div>
              <div>
                申请<span style={{ color: "#814F13" }}>免费体验</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Button
            style={{ width: 88, backgroundColor: "#814F13" }}
            type="primary"
            onClick={() => window.open(`${APP_URL}#/pay-vip`)}
          >
            查看权益
          </Button>
        </div>
      </div>
    ),
  });
};

// 升级校园版VIP
const showUpgradeSchoolVipModal = () => {
  const descList = [
    {
      icon: xgkIcon1,
      name: "学生选科",
    },
    {
      icon: xgkIcon2,
      name: "智能分班",
    },
    {
      icon: xgkIcon3,
      name: "开班计划",
    },
    {
      icon: xgkIcon4,
      name: "走班排课",
    },
    {
      icon: xgkIcon5,
      name: "更多服务",
    },
  ];

  Modal.info({
    ...commonModalProps,
    content: (
      <div
        style={{
          width: 640,
          padding: 40,
          background: `url(${bgSchool}) no-repeat`,
          backgroundSize: "100% 100%",
        }}
      >
        <div style={{ fontSize: 24, fontWeight: 700, color: "#814F13", marginBottom: 24 }}>
          您当前的会员权益不包含该功能
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 32 }}>
          <div
            style={{
              padding: "16px 34px",
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#FFF8E9",
              width: 270,
            }}
          >
            <div style={{ fontSize: 16, color: "#814F13", fontWeight: 500, marginBottom: 16 }}>
              升级权益，可使用以下功能
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "16px 24px",
                justifyContent: "center",
              }}
            >
              {descList.map((item, i) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 12,
                    color: "#4E5969",
                    width: 48,
                  }}
                  key={i}
                >
                  <img src={item.icon} style={{ width: 20, height: 20 }} alt="" />
                  {item.name}
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              padding: 10,
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#FFF8E9",
              display: "flex",
              alignItems: "center",
              gap: 10,
              alignSelf: "flex-end",
            }}
          >
            <img src={xzbQrcode} style={{ width: 92, height: 92 }} alt="" />
            <div style={{ fontSize: 12, color: "#4E5969", textAlign: "center" }}>
              <div>扫描二维码，联系客服可</div>
              <div>
                申请<span style={{ color: "#814F13" }}>免费体验</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Button
            style={{ width: 88, backgroundColor: "#814F13" }}
            type="primary"
            onClick={() => {
              report.event("upgrade_entry_click", { target: "kuaijw-compare" });
              window.open(getVersionGuideUrl("kuaipk-upgrade-compare"));
            }}
          >
            权益对比
          </Button>
        </div>
      </div>
    ),
  });
};

const showInsVipModal = (config?: Config) => {
  const { reason } = config || {};

  return Modal.confirm({
    ...commonModalProps,
    content: (
      <div
        style={{
          width: 640,
          padding: 40,
          background: `url(${imgInsBg}) no-repeat`,
          backgroundSize: "100% 100%",
        }}
      >
        <div style={{ height: 130 }}>
          <div
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#1D2129",
              width: 360,
              lineHeight: 1.3,
              marginBottom: 12,
            }}
          >
            {reason ? `${reason}，` : ""}开通<span style={{ color: "#467FF0" }}>机构版VIP</span>
            可使用该功能
          </div>
          <div style={{ fontSize: 15, color: "#4E5969" }}>10秒出课表，解决复杂排课的教务软件</div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 32 }}>
          <div
            style={{
              padding: "24px 16px",
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#EBF1FF",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: 16,
                fontWeight: 500,
                marginBottom: 16,
              }}
            >
              <img src={iconIns1} alt="" style={{ width: 24, height: 24, marginRight: 16 }} />
              <span>排课</span>
              <span style={{ color: "#467FF0" }}>条件充足</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", fontSize: 16, fontWeight: 500 }}>
              <img src={iconIns2} alt="" style={{ width: 24, height: 24, marginRight: 16 }} />
              <span>教务信息全校师生</span>
              <span style={{ color: "#467FF0" }}>共享同步</span>
            </div>
          </div>
          <div
            style={{
              padding: 10,
              borderRadius: 8,
              border: "1px solid #fff",
              background: "#EBF1FF",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img src={xzbQrcode} style={{ width: 92, height: 92 }} alt="" />
            <div style={{ fontSize: 12, color: "#4E5969", textAlign: "center" }}>
              <div>扫描二维码，联系客服可</div>
              <div>
                申请<span style={{ color: "#467FF0" }}>免费体验</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Button
            style={{ width: 88, backgroundColor: "#467FF0" }}
            type="primary"
            onClick={() => window.open(`${APP_URL}#/pay-vip`)}
          >
            查看权益
          </Button>
        </div>
      </div>
    ),
  });
};

// 仅新高考(走班/选分排)权限、不在行政班基础版权限内的，含该权益的最低档为走班排课
const isNceeOnlyPerm = (perm: string) =>
  !!perm &&
  rolePermMap.KUAIJW_NCEE_CLASS.includes(perm) &&
  !rolePermMap.KUAIJW_CLASS.includes(perm);

export const showOpenVipModalByPerm = (perm: string, reason?: string) => {
  const userVipInfo = store.getState().user.userVipInfo;

  const { isJwVip } = getVipType(userVipInfo?.vipList);
  const isJwApp = isJwInlandApp || isJwIntlApp;

  // 需要机构版权限
  if (perm && rolePermMap.INS_VIP_KUAIPK.includes(perm)) {
    return showInsVipModal({ reason });
  }

  // 教务端：课时统计/调代课/数量上限等权限代码同时存在于个人SVIP与教务权限表，
  // 优先按教务版权益引导（跳快教务落地页），避免把教务用户导去个人版弹窗
  if (isJwApp) {
    if (isJwVip) {
      // 已是教务版，提示升级更高档
      return showUpgradeSchoolVipModal();
    }
    return showKuaijwVipModal({ reason, plan: isNceeOnlyPerm(perm) ? "ncee" : "basic" });
  }

  // 需要个人SVIP权益
  if (perm && rolePermMap.VIP_KUAIPK_20240617.includes(perm)) {
    return showPersonalVipModal({ reason });
  }

  // 需要快教务权益（多人协同、方案分享、监考等）
  if (
    perm &&
    (rolePermMap.KUAIJW_NCEE_CLASS.includes(perm) || rolePermMap.KUAIJW_CLASS.includes(perm))
  ) {
    return showKuaijwVipModal({ reason, plan: isNceeOnlyPerm(perm) ? "ncee" : "basic" });
  }

  message.error("访问受限！此功能需要开通VIP");
};

export const showOpenVipModalByRoleTags = (roleTags: IVipRoleType[], reason?: string) => {
  const userVipInfo = store.getState().user.userVipInfo;
  const { isJwVip: currentIsJwVip, isPersonalVIP: currentIsPersonalVIP } = getVipType(
    userVipInfo?.vipList,
  );

  const { isJwVip, isPersonalVIP, isInsVIP } = getVipType(
    roleTags.map((item) => ({
      tag: item,
      vip: true,
    })),
  );

  if (isPersonalVIP) {
    if (currentIsPersonalVIP) {
      return showSchoolVipModal({ reason });
    }
    return showPersonalVipModal({ reason });
  }

  if (isInsVIP) {
    return showInsVipModal({ reason });
  }

  if (isJwVip) {
    if (currentIsJwVip) {
      return showUpgradeSchoolVipModal();
    }
    return showKuaijwVipModal({ reason });
  }

  message.error(`${reason || "访问受限"}！此功能需要开通VIP`);
};

export const showOpenVipModalByCurrentUser = (reason?: string) => {
  const userVipInfo = store.getState().user.userVipInfo;
  const { isJwVip, isPersonalVIP, isInsVIP } = getVipType(userVipInfo?.vipList);
  // 没有perm时，按照用户当前vip类型，弹出对应vip提示
  // 如果是个人vip，显示升级校园版弹窗
  if (isPersonalVIP) {
    return showSchoolVipModal({ reason });
  }

  if (isInsVIP) {
    return showInsVipModal({ reason });
  }

  // 如果是校园版（缺少部分权限），显示升级功能弹窗
  if (isJwVip) {
    return showUpgradeSchoolVipModal();
  }

  showPersonalVipModal({ reason });
};

export const showOpenVipModal = ({
  perm,
  roleTags,
  reason,
}: {
  perm?: string;
  roleTags?: IVipRoleType[];
  reason?: string;
}) => {
  if (perm) {
    return showOpenVipModalByPerm(perm, reason);
  }
  if (roleTags) {
    return showOpenVipModalByRoleTags(roleTags, reason);
  }
  showOpenVipModalByCurrentUser(reason);
};
